import * as yup from "yup"
import type { Genre } from "../../types"

export function initialValuesGenre(genre?: Genre | undefined) {
  if (genre) {
    return genre
  }
  return {
    name: "",
    record_media_type: "",
  }
}

export function validationSchemaGenre() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    record_media_type: yup.string().required("Campo obbligatorio"),
  })
}
